/**
 * A message for the sign-in page, for when the app signs someone out on purpose
 * and they should be told why (a master who changes their own email ends their
 * own session). Kept in sessionStorage so it survives the reload that signing
 * out does.
 *
 * It is read without being removed: signing out mounts the sign-in page once in
 * the running app and again after the reload, so a read-once notice was gone
 * before the person could see it. It is cleared when they next sign in.
 */
const KEY = 'signInNotice';

export function setSignInNotice(message) {
  try { sessionStorage.setItem(KEY, message); } catch { /* storage unavailable */ }
}

/** The pending notice, or an empty string. */
export function readSignInNotice() {
  try { return sessionStorage.getItem(KEY) || ''; } catch { return ''; }
}

export function clearSignInNotice() {
  try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
}
